import { FleekError } from './FleekError';

type Site = {
  id?: string;
  slug?: string;
  name?: string;
};

type SiteNotFoundErrorOptions = {
  site: Site;
};

export class SiteNotFoundError extends FleekError<SiteNotFoundErrorOptions> {
  public name = 'SiteNotFoundError';

  toString = () => {
    if (this.data.site.slug) {
      return `Site ${this.data.site.slug} not found.`;
    }

    return `Site not found.`;
  };
}
